import React, { useContext } from 'react';
import { CompactViewContext } from '../Providers/CompactViewProvider';
import { VideoPlayer } from '../../VideoPlayer';
import { VideoCarouselContext } from '../Providers/VideoCarouselProvider';
const getVideoProps = ({ isCurrent, isCompact, isAffordanceVideo, carouselPlay, hasInteracted, }) => {
    if (isAffordanceVideo) {
        return {
            autoplay: false,
            disabled: true,
            disabledUntilHover: false,
            playOnHover: false,
            toggleVolumeOnClick: false,
        };
    }
    if (isCurrent) {
        if (isCompact) {
            return {
                autoplay: carouselPlay || false,
                disabled: false,
                disabledUntilHover: false,
                playOnHover: false,
            };
        }
        return {
            autoplay: (!hasInteracted && carouselPlay) || false,
            disabled: false,
            disabledUntilHover: hasInteracted,
            playOnHover: hasInteracted && carouselPlay,
        };
    }
    return {
        autoplay: false,
        disabled: false,
        disabledUntilHover: true,
        playOnHover: carouselPlay,
    };
};
export const VideoCarouselSlide = ({ video, affordanceState, isCurrent, hasInteracted, }) => {
    const { isCompact } = useContext(CompactViewContext);
    const { carouselPlay, isCarouselMuted, toggleCarouselMute, toggleCarouselPlay, } = useContext(VideoCarouselContext);
    const videoPlayerProps = {
        ...video,
        ...{
            playButtonOnLoad: false,
            toggleVolumeOnClick: true,
            useDefaultThumbnail: false,
            customThumbnailType: video.customThumbnailType || 'timestamp',
            customThumbnailTimestamp: video.customThumbnailTimestamp || '0',
            overrideMute: isCarouselMuted,
            onTogglePlay: toggleCarouselPlay,
            onToggleMute: toggleCarouselMute,
            ...getVideoProps({
                isCurrent,
                isCompact,
                isAffordanceVideo: affordanceState !== null,
                carouselPlay,
                hasInteracted,
            }),
        },
    };
    return React.createElement(VideoPlayer, { ...videoPlayerProps });
};
